import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';
import { comprimiFoto, accodaFoto, fotoInCoda, sincronizzaFoto } from '../services/foto';

const MAX_FOTO = 8;

export default function FotoIntervento({ interventoId, soloLettura = false }) {
  const [foto, setFoto]       = useState([]);
  const [inCoda, setInCoda]   = useState([]);
  const [busy, setBusy]       = useState(false);
  const [msg, setMsg]         = useState('');
  const inputRef              = useRef(null);

  const carica = useCallback(async () => {
    try {
      const r = await api.get(`/intervento/${interventoId}/foto`);
      setFoto(r.data?.data || []);
    } catch (e) { /* offline: mostra solo la coda */ }
    setInCoda(await fotoInCoda(Number(interventoId)));
  }, [interventoId]);

  useEffect(() => { carica(); }, [carica]);

  useEffect(() => {
    const sync = async () => {
      const r = await sincronizzaFoto(Number(interventoId));
      if (r.inviate > 0 || r.scartate > 0) {
        if (r.scartate > 0) setMsg(`${r.scartate} foto non accettate dal server.`);
        carica();
      }
    };
    window.addEventListener('online', sync);
    const t = setInterval(sync, 30000);
    sync();
    return () => { window.removeEventListener('online', sync); clearInterval(t); };
  }, [interventoId, carica]);

  const totale = foto.length + inCoda.length;

  const aggiungi = async (e) => {
    const files = Array.from(e.target.files || []);
    if (inputRef.current) inputRef.current.value = '';
    if (files.length === 0) return;

    if (totale + files.length > MAX_FOTO) {
      setMsg(`Massimo ${MAX_FOTO} foto per intervento.`);
      return;
    }
    setBusy(true); setMsg('');

    for (const file of files) {
      try {
        const b64 = await comprimiFoto(file);
        if (navigator.onLine) {
          try {
            await api.post(`/intervento/${interventoId}/foto`, { base64: b64 });
          } catch (err) {
            if (!err.response) await accodaFoto(Number(interventoId), b64, null);
            else setMsg(err.response?.data?.error || 'Errore nel caricamento.');
          }
        } else {
          await accodaFoto(Number(interventoId), b64, null);
        }
      } catch (err) {
        setMsg('Immagine non leggibile: ' + err.message);
      }
    }
    await carica();
    setBusy(false);
  };

  const elimina = async (f) => {
    if (!window.confirm('Eliminare questa foto?')) return;
    try { await api.delete(`/intervento/${interventoId}/foto/${f.id}`); carica(); }
    catch (e) { setMsg('Impossibile eliminare la foto.'); }
  };

  return (
    <div className="card no-print" style={{ padding:16, marginBottom:16 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <strong style={{ fontSize:14 }}>📷 Foto intervento</strong>
        <span style={{ fontSize:12, color:'#6b7280' }}>{totale}/{MAX_FOTO}</span>
      </div>

      {!soloLettura && (
        <div style={{ marginTop:10 }}>
          <input ref={inputRef} type="file" accept="image/*" capture="environment"
            multiple onChange={aggiungi} disabled={busy || totale >= MAX_FOTO}
            style={{ fontSize:13 }} />
          {busy && <span style={{ marginLeft:8, fontSize:12, color:'#6b7280' }}>Elaborazione…</span>}
        </div>
      )}

      {msg && <div style={{ marginTop:10, fontSize:12, color:'#b45309' }}>⚠️ {msg}</div>}

      {inCoda.length > 0 && (
        <div style={{ marginTop:10, background:'#fef9c3', color:'#854d0e',
                      padding:8, borderRadius:6, fontSize:12 }}>
          📴 {inCoda.length} foto in attesa di invio: restano sul dispositivo
          finché non torna la rete.
        </div>
      )}

      <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginTop:12 }}>
        {foto.map(f => (
          <div key={f.id} style={{ position:'relative' }}>
            <img src={f.url} alt="" style={{ width:100, height:100, objectFit:'cover',
              borderRadius:6, border:'1px solid #e5e7eb' }} />
            {!soloLettura && (
              <button onClick={()=>elimina(f)}
                style={{ position:'absolute', top:2, right:2, border:'none',
                         background:'rgba(220,38,38,.9)', color:'#fff', borderRadius:4,
                         width:20, height:20, cursor:'pointer', fontSize:11, lineHeight:1 }}>✕</button>
            )}
          </div>
        ))}
        {inCoda.map(f => (
          <img key={f.clientId} src={f.base64} alt=""
            style={{ width:100, height:100, objectFit:'cover', borderRadius:6,
                     border:'2px dashed #eab308', opacity:.75 }} />
        ))}
      </div>
    </div>
  );
}
